import Loading from '@/components/Loading';
import AuthGuard from '@/components/SidePanel/AuthGuard';
import PrivateRoutes from '@/components/SidePanel/PrivateRoutes';
const AdminViewFormDashboard = lazy(
  () => import('../../pages/dashboard/admin/adminViewForm/AdminViewFormDashboard')
);
import Plaintiffs from '@/pages/plaintiffs/Plaintiffs';
import SectionPage from '@/pages/plaintiffSheets/components/SectionPage/SectionPage';
import PlaintiffSheets from '@/pages/plaintiffSheets/PlaintiffSheets';
const DashboardPage = lazy(() => import('../../pages/dashboard/admin/Dashboard'));
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

import PreviewDashboard from '@/pages/dashboard/preview/PreviewDashboard';
const AdminRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <AuthGuard allowedRoles={['admin']}>
        <PrivateRoutes />
      </AuthGuard>
    ),
    children: [
      {
        path: 'dashboard/:districtName/:districtId/:id',
        element: (
          <Suspense fallback={<Loading />}>
            <AdminViewFormDashboard />
          </Suspense>
        ),
      },
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<Loading />}>
            <DashboardPage />
          </Suspense>
        ),
      },
      {
        path: 'plaintiffs',
        element: (
          <Suspense fallback={<Loading />}>
            <Plaintiffs />
          </Suspense>
        ),
      },

      {
        path: 'plaintiffSheets',
        element: (
          <Suspense fallback={<Loading />}>
            <PlaintiffSheets />
          </Suspense>
        ),
      },
      {
        path: 'plaintiffSheets/section/:id',
        element: (
          <Suspense fallback={<Loading />}>
            <SectionPage />
          </Suspense>
        ),
      },
      {
        path: 'plaintiffSheets/preview',
        element: (
          <Suspense fallback={<Loading />}>
            <PreviewDashboard />
          </Suspense>
        ),
      },
    ],
  },
];

export default AdminRoutes;
